import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

// import Home from "../views/Home.vue";
import Index from "../views/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Index,
    meta: {
      title: "Route Line",
      layout: "default",
    },
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import("../views/About.vue"),
  // },
  {
    path: "/vehicles",
    name: "Vehicles",
    component: () => import("../views/vehicles/index.vue"),
  },
  {
    path: "/vehicles/:id",
    name: "Vehicles",
    component: () => import("../views/vehicles/vehicle/index.vue"),
  },
  {
    path: "/membership",
    name: "Membership",
    component: () => import("../views/membership.vue"),
    // beforeEnter() {
    //   window.location.href = "https://www.welcometorouteline.com/";
    // },
  },
  // {
  //   path: "/checkout/:id",
  //   name: "Checkout",
  //   component: () => import("../views/checkout/index.vue"),
  // },
  {
    path: "/trips",
    name: "Trips",
    component: () => import("../views/trips/index.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/user/Profile.vue"),
  },

  // auth routes
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      title: "Route Line",
      layout: "blank",
    },
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/auth/signup.vue"),
    meta: {
      title: "Route Line",
      layout: "blank",
    },
  },
  // {
  //   path: "/career",
  //   name: "Career",
  //   component: () => import("../views/career.vue"),
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/contact",
  //   name: "Contact",
  //   component: () => import("../views/contact.vue"),
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/privacy",
  //   name: "Privacy",
  //   component: () => import("../views/privacy.vue"),
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/terms",
  //   name: "Terms",
  //   component: () => import("../views/terms.vue"),
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/faq",
  //   name: "FAQ",
  //   component: () => import("../views/faq.vue"),
  //   beforeEnter() {
  //     window.location.href = "https://routeline.helpscoutdocs.com/";
  //   },
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/refund-policy",
  //   name: "Refund Policy",
  //   component: () => import("../views/refund-policy.vue"),
  //   meta: {
  //     title: "Route Line",
  //   },
  // },
  // {
  //   path: "/vehicle-type/ovp4",
  //   name: "Vechile Detaills",
  //   component: () => import("../views/vehicleType/ovp4.vue"),
  //   meta: {
  //     title: "Route Line Vehicle View",
  //   },
  // },
  // {
  //   path: "/vehicle-type/ovp2",
  //   name: "Vechile Detaills",
  //   component: () => import("../views/vehicleType/ovp2.vue"),
  //   meta: {
  //     title: "Route Line Vehicle View",
  //   },
  // },
  // {
  //   path: "/vehicle-type/camper",
  //   name: "Vechile Detaills",
  //   component: () => import("../views/vehicleType/camper.vue"),
  //   meta: {
  //     title: "Route Line Vehicle View",
  //   },
  // },
  // {
  //   path: "/vehicle-type/taxa",
  //   name: "Vechile Detaills",
  //   component: () => import("../views/vehicleType/taxa.vue"),
  //   meta: {
  //     title: "Route Line Vehicle View",
  //   },
  // },
  {
    path: "/customer/create",
    component: () => import("../views/CustomerCreate.vue"),
    meta: {
      title: "Customer Create",
      layout: "blank",
      // auth: true
    },
  },
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    const position = savedPosition || {
      x: 0,
      y: 0,
    };
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(position);
      }, 200);
    });
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.auth) {
    if (!store.state.user) {
      localStorage.setItem("goBackTo", to.path);
      router.push("/");
      return;
    } else {
      // if ( store.state.isPlanExpired && to.meta.name !== "planView" ) {
      //   if ( from.meta.name !== "planView" ) {
      //     router.push(`/settings/subscription/${store.state.planId}?model=true`);
      //   }
      //   NProgress.done();
      //   return;
      // }
      // store.dispatch("toggleSideDrawer", true);
    }
  }

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle)
    document.title =
      nearestWithTitle.meta.title +
      ((nearestWithTitle.meta.title.indexOf("Route Line") === -1 &&
        " · Route Line") ||
        "");
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  Array.from(document.querySelectorAll("[data-routerMetas]")).map((el) =>
    el.parentNode.removeChild(el)
  );
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute("data-routerMetas", "");
      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));
  next();
});

export default router;
